var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bacontainer",style:(_setup.styleObj)},[_c('div',{staticClass:"bacontainer-legend"},[_vm._v(_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"bacontainer-main"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }